import { isComputerModel } from '#pplx/frontend/ask-models/types/search-modes.js';
// Whether a computer follow-up has an orchestrator control to render. The
// caller decides between the switcher dropdown and the read-only chip; it
// includes the generic default (SearchModel.ASI) so the switcher can still be
// offered there without a read-only chip revealing the resolved model.
export function useComputerModelChip({ configuredModel, isFollowUp, }) {
    if (!isFollowUp || !isComputerModel(configuredModel)) {
        return { showComputerModelChip: false };
    }
    return { showComputerModelChip: true, model: configuredModel };
}
//# sourceMappingURL=useComputerModelChip.js.map